function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { createElement, useMemo, useState, useCallback, useEffect } from 'react';

var ImageSliderPreLoader = function () {
  var loadedUrl = {};
  var loadQueue = [];
  var loaderCount = 3;
  var loaderPool = new Array(loaderCount).fill(0).map(function () {
    return new Image();
  });
  return {
    load: function load(url) {
      if (!url || loadedUrl[url]) {
        return;
      }

      if (loaderPool.length === 0) {
        loadQueue.push(url);
      } else {
        var imageLoader = loaderPool.shift();
        imageLoader.src = url;

        imageLoader.onload = function () {
          loadedUrl[url] = true;

          if (loadQueue.length > 0) {
            imageLoader.src = loadQueue.shift();
          } else {
            loaderPool.push(imageLoader);
          }
        };
      }
    }
  };
}();

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3e %3cdefs%3e %3cfilter id='0ls8o9a99a' width='168.9%25' height='218.6%25' x='-34.5%25' y='-59.3%25' filterUnits='objectBoundingBox'%3e %3cfeOffset in='SourceAlpha' result='shadowOffsetOuter1'/%3e %3cfeGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='2'/%3e %3cfeColorMatrix in='shadowBlurOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0'/%3e %3c/filter%3e %3cpath id='rs87bry78b' d='M19 7L20.413 8.414 11.707 17.12 2.999 8.414 4.413 7 11.707 14.291z'/%3e %3c/defs%3e %3cg fill='none' fill-rule='evenodd'%3e %3cg%3e %3cg%3e %3cg transform='translate(-24 -27) translate(24 27) rotate(90 11.707 12.06)'%3e %3cuse fill='black' filter='url(%230ls8o9a99a)' xlink:href='%23rs87bry78b'/%3e %3cuse fill='white' xlink:href='%23rs87bry78b'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3e %3cdefs%3e %3cfilter id='8utpkffr2a' width='171.8%25' height='232.4%25' x='-35.9%25' y='-66.2%25' filterUnits='objectBoundingBox'%3e %3cfeOffset in='SourceAlpha' result='shadowOffsetOuter1'/%3e %3cfeGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='2'/%3e %3cfeColorMatrix in='shadowBlurOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0'/%3e %3c/filter%3e %3cpath id='6inzdknobb' d='M20 6.999L20.707 7.706 12.354 16.06 4 7.706 4.707 6.999 12.354 14.646z'/%3e %3c/defs%3e %3cg fill='none' fill-rule='evenodd'%3e %3cg%3e %3cg%3e %3cg transform='translate(-67 -27) translate(67 27) rotate(90 12.354 11.53)'%3e %3cuse fill='black' filter='url(%238utpkffr2a)' xlink:href='%236inzdknobb'/%3e %3cuse fill='white' xlink:href='%236inzdknobb'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var ImageSliderNavStyle;

(function (ImageSliderNavStyle) {
  ImageSliderNavStyle[ImageSliderNavStyle["NORMAL"] = 1] = "NORMAL";
  ImageSliderNavStyle[ImageSliderNavStyle["BOLD"] = 2] = "BOLD";
})(ImageSliderNavStyle || (ImageSliderNavStyle = {}));

var ImageSliderNavDirection;

(function (ImageSliderNavDirection) {
  ImageSliderNavDirection["LEFT"] = "left";
  ImageSliderNavDirection["RIGHT"] = "right";
})(ImageSliderNavDirection || (ImageSliderNavDirection = {}));

var altNavArrowLeft = 'slide to left';
var altNavArrowRight = 'slide to right';

var ImageSliderNavigation = function ImageSliderNavigation(props) {
  return React.createElement("button", {
    type: "button",
    style: styles.getNavStyle(props.direction, props.navSize, props.navMargin),
    onClick: props.onClickNav(props.direction)
  }, React.createElement("img", {
    src: props.navStyle === ImageSliderNavStyle.NORMAL ? img$1 : img,
    style: _objectSpread({
      width: '100%'
    }, props.direction === ImageSliderNavDirection.RIGHT && {
      transform: 'rotate(180deg)'
    }),
    alt: props.direction === ImageSliderNavDirection.LEFT ? altNavArrowLeft : altNavArrowRight
  }));
};

var basic = {
  display: 'block',
  margin: '0',
  padding: '0',
  border: '0'
};
var basicRootContainer = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};
var basicSlide = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover'
};
var basicNav = {
  position: 'absolute',
  top: '50%',
  cursor: 'pointer',
  outline: 'none',
  background: 'none'
};
var bulletContainer = {
  position: 'absolute',
  left: '50%',
  bottom: '15px'
};
var bulletSize = 15;
var bulletMargin = 3;
var basicBullet = {
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  background: 'none',
  boxShadow: '1px 1px 1px 0px #1a1a1a',
  borderRadius: '50%',
  border: '1px solid #FFFFFF',
  width: "".concat(bulletSize, "px"),
  height: "".concat(bulletSize, "px"),
  marginLeft: "".concat(bulletMargin, "px"),
  marginRight: "".concat(bulletMargin, "px")
};
var styles = {
  ImageSlider: _objectSpread(_objectSpread({}, basic), basicRootContainer),
  ImageSlideCurrent: _objectSpread(_objectSpread({}, basicSlide), {}, {
    overflow: 'hidden'
  }),
  ImageSlideNext: _objectSpread(_objectSpread({}, basicSlide), {}, {
    overflow: 'hidden'
  }),
  NavLeft: _objectSpread(_objectSpread(_objectSpread({}, basic), basicNav), {}, {
    left: '30px',
    marginTop: '-25px'
  }),
  NavRight: _objectSpread(_objectSpread(_objectSpread({}, basic), basicNav), {}, {
    right: '30px',
    marginTop: '-25px'
  }),
  BulletNormal: _objectSpread(_objectSpread({}, basic), basicBullet),
  BulletActive: _objectSpread(_objectSpread(_objectSpread({}, basic), basicBullet), {}, {
    background: '#FFF'
  }),
  getRootContainer: function getRootContainer(width, height, backgroundColor) {
    return _objectSpread(_objectSpread({}, basic), {}, {
      overflow: 'hidden',
      width: width,
      height: height,
      backgroundColor: backgroundColor
    });
  },
  getSubContainer: function getSubContainer(width, height) {
    return _objectSpread(_objectSpread({}, basic), {}, {
      position: 'absolute',
      overflow: 'hidden',
      width: width,
      height: height
    });
  },
  getBulletContainer: function getBulletContainer(bulletLength) {
    return _objectSpread(_objectSpread(_objectSpread({}, basic), bulletContainer), {}, {
      marginLeft: "-".concat(bulletLength * (bulletSize + bulletMargin * 2) / 2, "px")
    });
  },
  getImageSlide: function getImageSlide(url, duration, idx, isGpuRender) {
    return _objectSpread(_objectSpread({}, basicSlide), {}, {
      overflow: 'hidden',
      transition: "".concat(duration, "s"),
      backgroundImage: "url(".concat(url, ")"),
      transform: isGpuRender ? "translate3d(".concat(idx * 100, "%, 0px, 0px)") : "translate(".concat(idx * 100, "%, 0px)")
    });
  },
  getNavStyle: function getNavStyle(direction, size, margin) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basic), basicNav), direction === ImageSliderNavDirection.LEFT ? {
      left: "".concat(margin, "px")
    } : {
      right: "".concat(margin, "px")
    }), {}, {
      marginTop: "-".concat(Math.floor(size / 2), "px"),
      width: "".concat(size, "px")
    });
  }
};

var ImageSliderBullets = function ImageSliderBullets(_ref) {
  var length = _ref.length,
      currentIdx = _ref.currentIdx,
      onClickBullets = _ref.onClickBullets;
  return createElement("div", {
    style: styles.getBulletContainer(length)
  }, Array.from(Array(length).keys()).map(function (idx) {
    return createElement("button", {
      key: "bullet-".concat(idx),
      type: "button",
      "data-id": "bullet-".concat(idx),
      style: idx === currentIdx ? styles.BulletActive : styles.BulletNormal,
      onClick: function onClick() {
        return onClickBullets(idx);
      }
    });
  }));
};

var SimpleImageSlider = function SimpleImageSlider(_ref2) {
  var _images$;

  var width = _ref2.width,
      height = _ref2.height,
      images = _ref2.images,
      showNavs = _ref2.showNavs,
      showBullets = _ref2.showBullets,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? undefined : _ref2$style,
      _ref2$slideDuration = _ref2.slideDuration,
      slideDuration = _ref2$slideDuration === void 0 ? 0.5 : _ref2$slideDuration,
      _ref2$bgColor = _ref2.bgColor,
      bgColor = _ref2$bgColor === void 0 ? '#000' : _ref2$bgColor,
      _ref2$useGPURender = _ref2.useGPURender,
      useGPURender = _ref2$useGPURender === void 0 ? true : _ref2$useGPURender,
      _ref2$navSize = _ref2.navSize,
      navSize = _ref2$navSize === void 0 ? 50 : _ref2$navSize,
      _ref2$navMargin = _ref2.navMargin,
      navMargin = _ref2$navMargin === void 0 ? 30 : _ref2$navMargin,
      _ref2$navStyle = _ref2.navStyle,
      navStyle = _ref2$navStyle === void 0 ? ImageSliderNavStyle.NORMAL : _ref2$navStyle,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? undefined : _ref2$onClick,
      _ref2$onClickNav = _ref2.onClickNav,
      onClickNav = _ref2$onClickNav === void 0 ? undefined : _ref2$onClickNav,
      _ref2$onClickBullets = _ref2.onClickBullets,
      onClickBullets = _ref2$onClickBullets === void 0 ? undefined : _ref2$onClickBullets,
      _ref2$onStartSlide = _ref2.onStartSlide,
      onStartSlide = _ref2$onStartSlide === void 0 ? undefined : _ref2$onStartSlide,
      _ref2$onCompleteSlide = _ref2.onCompleteSlide,
      onCompleteSlide = _ref2$onCompleteSlide === void 0 ? undefined : _ref2$onCompleteSlide;
  var rootStyle = useMemo(function () {
    return styles.getRootContainer(width, height, bgColor);
  }, [width, height, bgColor]);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      slideIdx = _useState2[0],
      setSlideIdx = _useState2[1];

  var _useState3 = useState(ImageSliderNavDirection.RIGHT),
      _useState4 = _slicedToArray(_useState3, 2),
      slideDirection = _useState4[0],
      setSlideDirection = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSliding = _useState6[0],
      setIsSliding = _useState6[1];

  var _useState7 = useState(styles.getImageSlide(images[0].url, slideDuration, 0, useGPURender)),
      _useState8 = _slicedToArray(_useState7, 2),
      currentSliderStyle = _useState8[0],
      setCurrentSlideStyle = _useState8[1];

  var _useState9 = useState(styles.getImageSlide((_images$ = images[1]) === null || _images$ === void 0 ? void 0 : _images$.url, slideDuration, 1, useGPURender)),
      _useState10 = _slicedToArray(_useState9, 2),
      nextSliderStyle = _useState10[0],
      setNextSliderStyle = _useState10[1];

  var handleClick = useCallback(function (event) {
    onClick === null || onClick === void 0 ? void 0 : onClick(slideIdx, event);
  }, [slideIdx]);
  var handleClickNav = useCallback(function (direction) {
    return function () {
      if (isSliding) {
        return;
      }

      var isRight = direction === ImageSliderNavDirection.RIGHT;
      onClickNav === null || onClickNav === void 0 ? void 0 : onClickNav(isRight);
      slide(isRight ? slideIdx + 1 : slideIdx - 1);
    };
  }, [slideIdx, isSliding]);
  var handleClickBullets = useCallback(function (idx) {
    if (idx === slideIdx || isSliding) {
      return;
    }

    onClickBullets === null || onClickBullets === void 0 ? void 0 : onClickBullets(idx);
    slide(idx);
  }, [slideIdx, isSliding]);

  var slide = function slide(idx) {
    var toNext = idx > slideIdx;
    var currentUrl = images[slideIdx].url;
    var nextUrl = images[idx].url;
    var nextReadyX = toNext ? 1 : -1;
    setSlideIdx(idx);
    setSlideDirection(idx > slideIdx ? ImageSliderNavDirection.RIGHT : ImageSliderNavDirection.LEFT);
    setCurrentSlideStyle(styles.getImageSlide(currentUrl, 0, 0, useGPURender));
    setNextSliderStyle(styles.getImageSlide(nextUrl, 0, nextReadyX, useGPURender));
    setIsSliding(true);
    onStartSlide === null || onStartSlide === void 0 ? void 0 : onStartSlide(idx + 1, images.length);
    idx + 2 < images.length && ImageSliderPreLoader.load(images[idx + 2].url);
  };

  useEffect(function () {
    if (isSliding) {
      setTimeout(function () {
        var toRight = slideDirection === ImageSliderNavDirection.RIGHT;
        var currentUrl = images[toRight ? slideIdx - 1 : slideIdx + 1].url;
        var nextUrl = images[slideIdx].url;
        var currentOffsetX = toRight ? -1 : 1;
        setCurrentSlideStyle(styles.getImageSlide(currentUrl, slideDuration, currentOffsetX, useGPURender));
        setNextSliderStyle(styles.getImageSlide(nextUrl, slideDuration, 0, useGPURender));
      }, 50);
    }
  }, [slideIdx, isSliding]);
  var handleSlideEnd = useCallback(function () {
    setCurrentSlideStyle(styles.getImageSlide(images[slideIdx].url, 0, 0, useGPURender));
    setIsSliding(false);
    onCompleteSlide === null || onCompleteSlide === void 0 ? void 0 : onCompleteSlide(slideIdx + 1, images.length);
  }, [slideIdx]);
  return React.createElement("div", {
    style: _objectSpread(_objectSpread({}, rootStyle), style)
  }, React.createElement("div", {
    style: styles.getSubContainer(width, height)
  }, React.createElement("div", {
    style: styles.ImageSlider,
    onClick: handleClick
  }, React.createElement("div", {
    style: currentSliderStyle,
    onTransitionEnd: handleSlideEnd
  }), images.length > 1 && React.createElement("div", {
    style: nextSliderStyle
  })), showNavs && images.length > 0 && slideIdx > 0 && React.createElement(ImageSliderNavigation, {
    direction: ImageSliderNavDirection.LEFT,
    navStyle: navStyle,
    navSize: navSize,
    navMargin: navMargin,
    onClickNav: handleClickNav
  }), showNavs && images.length > 0 && slideIdx < images.length - 1 && React.createElement(ImageSliderNavigation, {
    direction: ImageSliderNavDirection.RIGHT,
    navStyle: navStyle,
    navSize: navSize,
    navMargin: navMargin,
    onClickNav: handleClickNav
  }), showBullets && images.length > 0 && React.createElement(ImageSliderBullets, {
    length: images.length,
    currentIdx: slideIdx,
    onClickBullets: handleClickBullets
  })));
};

export default SimpleImageSlider;
